import { useTranslation } from "react-i18next";

import {
  QUOTE_REQUEST_NAME_COLUMN_WIDTH,
  QuoteRequestsTableData,
} from "#app/routes/pages/quote-requests/QuoteRequestsV2.page";
import { colors } from "#app/theme/v2/colors";
import { Text } from "#components/atoms/Typographies/Text";
import { Stack } from "#shared/view/components/Stack";

type Props = {
  quoteRequest: QuoteRequestsTableData;
};

export const QuoteRequestNameCell = ({ quoteRequest }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack w={QUOTE_REQUEST_NAME_COLUMN_WIDTH} gap={0}>
      <Text size="small" type="medium" truncate>
        {quoteRequest.reference}
      </Text>
      <Text size="tiny" type="regular" color={colors.text.secondaryDefault} truncate>
        {quoteRequest.clientName
          ? t("quoteRequestsV2.table.content.name", {
              clientName: quoteRequest.clientName,
              count: quoteRequest.uniqueLines.length,
            })
          : t("quoteRequestsV2.table.content.nameNoClient", {
              count: quoteRequest.uniqueLines.length,
            })}
      </Text>
    </Stack>
  );
};
